import { defineQuery } from 'next-sanity'
import { regionFields, amenityFields } from '../atoms'

export const nurserySearchBlockFields = `
  _id,
  _type,
  title,
  includeSearch,
  includeMap,
  "regionsFilters": regionsFilters[]->{
    ${regionFields}
  },
  "regionsPreSelected": regionsPreSelected[]->{
    ${regionFields}
  },
  "amenities": amenities[]->{
    ${amenityFields}
  }
`

export const NURSERY_SEARCH_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "nursery-search-block"][0]{
    ${nurserySearchBlockFields}
  }
`)
